import React, { useEffect, useState } from "react";
import { supabase } from "../supabase";

export default function Recipes() {
  const [recipes, setRecipes] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    fetchRecipes();
  }, []);

  const fetchRecipes = async () => {
    setLoading(true);
    const { data } = await supabase
      .from("recipes")
      .select("*, recipe_tags(tags(name))")
      .order("id", { ascending: false });
    if (data) setRecipes(data);
    setLoading(false);
  };

  const toggleStatus = async (id: number, status: string) => {
    const newStatus = status === "published" ? "draft" : "published";
    await supabase.from("recipes").update({ status: newStatus }).eq("id", id);
    fetchRecipes();
  };

  const deleteRecipe = async (id: number) => {
    if (!window.confirm("Удалить рецепт?")) return;
    await supabase.from("recipes").delete().eq("id", id);
    fetchRecipes();
  };

  const updatePhoto = async (id: number) => {
    const url = window.prompt("Введите URL фото:");
    if (!url) return;
    await supabase
      .from("recipes")
      .update({ media_urls: [url] })
      .eq("id", id);
    fetchRecipes();
  };

  const updateTitleEn = async (id: number, current: string) => {
    const newTitle = window.prompt("EN название:", current || "");
    if (newTitle === null) return;
    await supabase.from("recipes").update({ title_en: newTitle }).eq("id", id);
    fetchRecipes();
  };

  const filtered = recipes.filter((r) => {
    const matchSearch =
      r.title?.toLowerCase().includes(search.toLowerCase()) ||
      r.title_en?.toLowerCase().includes(search.toLowerCase());
    const matchFilter =
      filter === "all" ||
      r.status === filter ||
      (filter === "no_photo" && (!r.media_urls || r.media_urls.length === 0)) ||
      (filter === "no_en" && !r.title_en);
    return matchSearch && matchFilter;
  });

  return (
    <div>
      <div style={s.header}>
        <h1 style={s.title}>📖 Рецепты ({recipes.length})</h1>
      </div>
      <div style={s.toolbar}>
        <input
          style={s.search}
          placeholder="Поиск..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select
          style={s.select}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        >
          <option value="all">Все</option>
          <option value="published">Опубликованные</option>
          <option value="draft">Черновики</option>
          <option value="no_photo">⚠️ Без фото</option>
          <option value="no_en">⚠️ Без EN названия</option>
        </select>
      </div>
      {loading ? (
        <p>Загрузка...</p>
      ) : (
        <table style={s.table}>
          <thead>
            <tr style={s.thead}>
              <th style={s.th}>ID</th>
              <th style={s.th}>Название RU</th>
              <th style={s.th}>Название EN</th>
              <th style={s.th}>Статус</th>
              <th style={s.th}>Фото</th>
              <th style={s.th}>Действия</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.id} style={s.tr}>
                <td style={s.td}>{r.id}</td>
                <td style={s.td}>{r.title}</td>
                <td style={s.td}>
                  <span style={{ color: r.title_en ? "#222" : "#e74c3c" }}>
                    {r.title_en || "—"}
                  </span>
                </td>
                <td style={s.td}>
                  <span
                    style={{
                      ...s.badge,
                      backgroundColor:
                        r.status === "published" ? "#d5f5e3" : "#fef9e7",
                      color: r.status === "published" ? "#2ECC71" : "#f39c12",
                    }}
                  >
                    {r.status === "published" ? "Опубликован" : "Черновик"}
                  </span>
                </td>
                <td style={s.td}>
                  {r.media_urls?.length > 0 ? (
                    <img
                      src={r.media_urls[0]}
                      alt=""
                      style={{
                        width: 60,
                        height: 40,
                        objectFit: "cover",
                        borderRadius: 6,
                      }}
                    />
                  ) : (
                    <span style={{ color: "#e74c3c", fontSize: 12 }}>
                      Нет фото
                    </span>
                  )}
                </td>
                <td style={s.td}>
                  <button
                    style={s.btnSmall}
                    onClick={() => toggleStatus(r.id, r.status)}
                  >
                    {r.status === "published" ? "Скрыть" : "Опубл."}
                  </button>
                  <button
                    style={{ ...s.btnSmall, backgroundColor: "#9b59b6" }}
                    onClick={() => updateTitleEn(r.id, r.title_en)}
                  >
                    EN
                  </button>
                  <button
                    style={{ ...s.btnSmall, backgroundColor: "#3498db" }}
                    onClick={() => updatePhoto(r.id)}
                  >
                    📷
                  </button>
                  <button
                    style={{ ...s.btnSmall, backgroundColor: "#e74c3c" }}
                    onClick={() => deleteRecipe(r.id)}
                  >
                    Удалить
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
  },
  title: { fontSize: 24, fontWeight: 700, color: "#222", margin: 0 },
  toolbar: { display: "flex", gap: 12, marginBottom: 16 },
  search: {
    padding: "10px 14px",
    borderRadius: 8,
    border: "1px solid #eee",
    fontSize: 14,
    width: 300,
    outline: "none",
  },
  select: {
    padding: "10px 14px",
    borderRadius: 8,
    border: "1px solid #eee",
    fontSize: 14,
    outline: "none",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: "#fff",
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  },
  thead: { backgroundColor: "#f9f9f9" },
  th: {
    padding: "12px 16px",
    textAlign: "left",
    fontSize: 13,
    color: "#888",
    fontWeight: 600,
  },
  tr: { borderBottom: "1px solid #f0f0f0" },
  td: { padding: "12px 16px", fontSize: 14, color: "#222" },
  badge: {
    padding: "4px 10px",
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 500,
  },
  btnSmall: {
    padding: "6px 10px",
    backgroundColor: "#2ECC71",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    fontSize: 12,
    cursor: "pointer",
    marginRight: 4,
  },
};
